import { carregarPerfilDePermissaoDaStore } from '@/integracoes/src-next/catalogos/catalogos-governanca.vuex'
import { freezeItems } from './freezeItems'

function perfilEhRh (perfil) {
  return perfil?.kind === 'all'
}

export default {
  namespaced: true,
  state: {
    items: [],
    loading: false,
    pronto: false,
    atualizando: false,
    erro: null,
    sincronizadoEm: null
  },
  getters: {
    onlyNotRh (state) {
      return state.items.filter(i => !perfilEhRh(i))
    },
    notRhNorEmployee (state) {
      return state.items.filter(i => !perfilEhRh(i) && i.kind !== 'mine')
    },
    todosOsPerfis (state) {
      return state.items
    },
    notEmployee (state) {
      return state.items.filter(i => i.kind !== 'mine')
    },
    todasPermissoes (state) {
      return state.items
    },
    somentePermissoesDeFuncionario (state) {
      return state.items.filter(i => i.kind === 'mine')
    },
    somentePermissoesDeGestor (state) {
      return state.items.filter(i => i.kind === 'group')
    },
    somentePermissoesDeGestorERh (state) {
      return state.items.filter(i => i.kind === 'group' || i.kind === 'all')
    },
    somentePermissoesDeRh (state) {
      return state.items.filter(i => i.kind === 'all')
    },
    somentePermissoesComEhRh (state) {
      return state.items.filter(item => perfilEhRh(item))
    }
  },
  mutations: {
    saveItems (state, payload) {
      state.items = freezeItems(payload)
      state.loading = false
    },
    resetItems (state) {
      state.items = []
      state.pronto = false
      state.loading = false
      state.atualizando = false
      state.erro = null
      state.sincronizadoEm = null
    },
    publicarCatalogo (state, { items, ...estado }) {
      if (items !== undefined) state.items = freezeItems(items)
      Object.assign(state, estado)
    },
    loading (state, payload) {
      state.loading = Boolean(payload)
    }
  },
  actions: {
    async fetchItems ({ state, dispatch }, payload = {}) {
      if (payload.page !== undefined || payload.search || payload.id || (payload.withFields || []).some(campo => !['name', 'id', 'kind', 'description'].includes(campo))) return dispatch('consultarItensEspecificos', payload)
      await carregarPerfilDePermissaoDaStore(this, payload.fullReload === true)
      return state.items
    },
    async consultarItensEspecificos (contexto, payload = {}) {
      const { API, retryRequest } = await import('src/services')
      const result = await retryRequest(API.roleGroup.get, {
        fields: JSON.stringify([...new Set(['name', 'id', 'kind', 'description', ...(payload.withFields || [])])]),
        ...(payload.page !== undefined ? { page: payload.page, per_page: payload.per_page || 30 } : {}),
        ...(payload.search ? { search: payload.search } : {}),
        ...(payload.id ? { id: payload.id } : {})
      })
      return result.status === 204 ? { success: [], total: 0, totalPages: 0 } : result.body
    }
  }
}
